import GET_USERS from '@/shared/graphql/get-users.graphql';
import graphql from '@/shared/graphql';
import { acceptProps, compose } from 'vue-compose';
import UserLookup from './user-lookup.vue';
import { SortOrder } from '@/shared/schema/globalTypes';
const getUsers = graphql(GET_USERS, {
    options(props) {
        return {
            variables: {
                filters: {
                    active: props.filterActive
                },
                sort: [{ name: 'name', order: SortOrder.ASC }]
            }
        };
    },
    props(props) {
        const allUsers = !props.loading && props.data && props.data.users
            ? props.data.users.records.map(x => ({
                id: x.id,
                label: `${x.firstName} ${x.lastName}`,
                firstName: x.firstName,
                lastName: x.lastName,
                disabled: props.disableInactive && !x.active ? true : false,
                active: x.active
            }))
            : [];
        let value;
        let users = allUsers.filter(u => (props.disableInactive ? u.active : true));
        if (props.value) {
            if ('multiple' in props && props.multiple) {
                if (typeof props.value[0] == 'string') {
                    const ids = props.value;
                    value = ids.map(id => allUsers.find(user => user.id === id)).filter(Boolean);
                }
                else {
                    value = props.value;
                }
            }
            else {
                value = null;
                if (props.value) {
                    value =
                        typeof props.value === 'string'
                            ? allUsers.find(u => u.id === props.value)
                            : allUsers.find(u => u.id === props.value.id);
                }
            }
        }
        if (value) {
            const ensureInOptions = (user) => {
                if (user && !users.find(u => u.id === user.id)) {
                    users = [...users, user];
                }
            };
            if (Array.isArray(value)) {
                value.forEach(ensureInOptions);
            }
            else {
                ensureInOptions(value);
            }
        }
        return {
            loading: props.loading,
            users,
            value
        };
    }
});
export default compose(acceptProps(['filterActive', 'disableInactive']), getUsers, acceptProps({ value: { type: [Array, String, Object] } }))(UserLookup);
